export const helpCentreSections = [
  { id: "getting-started", label: "Getting started", order: 10 },
  { id: "domains", label: "Domains", order: 15 },
  { id: "hosting-tools", label: "Hosting tools", order: 20 },
  { id: "application-hosting", label: "Application hosting", order: 30 },
  { id: "comparisons", label: "Comparisons", order: 40 },
] as const;
